module.exports = __webpack_public_path__ + "img/Instagram_footer.f4436887.svg";